import { makeStyles, Theme } from "@material-ui/core/styles";
import { BaseCSSProperties } from "@material-ui/core/styles/withStyles";
import { changeAppState } from "../../../../../common/appState";
import { spaceBetween } from "../../../../../common/util/Array/spaceBetween";
import "../../../CharacterComment/CharacterComment.css";
import { OtherUser } from "../../types";
import { AlternativeAvatar } from "./AlternativeAvatar";
import { FriendButtonArea } from "./FriendButtonArea/FriendButtonArea";

type CommentProps = {
    screenWidth: number;
    comment: string | React.ReactNode;
    style?: BaseCSSProperties;
    commentStyle?: BaseCSSProperties;
    targetUser: OtherUser;
    imageSrc: string;
    isMyself: boolean;
};
export function PersonComment({
    comment,
    style,
    commentStyle,
    targetUser,
    imageSrc,
    isMyself,
}: CommentProps) {
    const c = usePersonCommentStyles({
        style,
        commentStyle,
        imageSrc,
        isMyself,
    });

    return (
        <div className={c.container}>
            <div className={c.imgContainer}>
                {imageSrc ? (
                    <img
                        src={imageSrc}
                        alt={targetUser.name}
                        title={targetUser.name}
                        className={spaceBetween("ninjaPic", c.img)}
                        onClick={() => {
                            changeAppState("imageDetailPanelState", {
                                open: true,
                                src: imageSrc.replace("width300", "width600"),
                            });
                        }}
                    />
                ) : (
                    <AlternativeAvatar
                        targetUser={targetUser}
                        isMyself={isMyself}
                    />
                )}
                {!isMyself && (
                    <FriendButtonArea
                        style={{ marginTop: 20 }}
                        targetUser={targetUser}
                    />
                )}
            </div>
            <div
                className={spaceBetween(
                    imageSrc ? "userChatting" : "chatting",
                    c.chatting
                )}
            >
                <div className={spaceBetween("says", c.says)}>{comment}</div>
            </div>
        </div>
    );
}
const usePersonCommentStyles = makeStyles<
    Theme,
    {
        style?: BaseCSSProperties;
        commentStyle?: BaseCSSProperties;
        imageSrc: string;
        isMyself: boolean;
    }
>(theme => ({
    container: ({ style }) => ({
        display: "flex",
        ...style,
    }),
    imgContainer: {
        flex: 1,
        marginTop: 6,
        marginRight: 10,
        display: "flex",
        flexDirection: "column",
    },
    img: {
        maxWidth: 300,
        height: "auto",
        verticalAlign: "top",
        cursor: "pointer",
        borderRadius: 4,
        boxShadow: `0 0 3px ${theme.palette.grey[400]}`,
    },
    chatting: ({ imageSrc, isMyself }) => ({
        flex: 2,
        paddingBottom: imageSrc || isMyself ? undefined : 60,
    }),
    says: ({ commentStyle }) => ({
        width: "100%",
        ...commentStyle,
    }),
}));
